import React from "react";
import { Updater, async, AsyncState, fromJSX, Widget } from "widgets-for-react";
import { ActualityPageData, PageResult } from "../../sharepointPageApi/types/pageData";
import { LinkBlock } from "../linkBlockLayout";
import { AllNewsBlockLayout } from './allNewsBlockLayout';

export type AllNewsBlock = Omit<LinkBlock, 'items'> & {
    newsState: AsyncState<PageResult<ActualityPageData>>
  }

export const allNewsBlockWidget = (
    block: AllNewsBlock
): Widget<Updater<AsyncState<PageResult<ActualityPageData>>>> =>
async<PageResult<ActualityPageData>>(block.newsState, (s) =>
    fromJSX(() => (
        <AllNewsBlockLayout {...block} children={s} />
    ))
  )